import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import {IFormTitleProps} from "./types";
import Icon from "@mui/material/Icon";
import {useTheme} from "@mui/material/styles";


export const FormTitle: React.FC<IFormTitleProps> = (
    {
        title,
        titleIcon,
        typeVariant="h3"
    }: IFormTitleProps
) => {
    const theme = useTheme();

    let iconFontSize = 5;
    switch (typeVariant) {
        case "h5":
            iconFontSize=3.5;
            break;
        case "h4":
            iconFontSize=4;
            break;
        case "h3":
        default:
            iconFontSize = 5;
            break;
    }

    return(
        <Box display="flex" alignItems="end" justifyContent="start" sx={{mb: 1.25}}>
            {titleIcon &&
                <Icon
                    sx={{
                        color: theme.daPalette.grey.dark,
                        fontSize: theme.spacing(iconFontSize),
                        marginRight: theme.spacing(2),
                    }}
                >
                    {titleIcon}
                </Icon>
            }
            <Typography variant={typeVariant}>{title}</Typography>
        </Box>
    );
}